import React from "react";
import { HandCoins, MessageCircle } from "lucide-react";
import { resolveMediaUrl } from "@/lib/imageProxy";
import { formatConversationDate } from "@/lib/chat";

export function ChatConversationRow({ conv, onClick, testidPrefix = "conversation" }) {
  return (
    <button
      type="button"
      data-testid={`${testidPrefix}-${conv.id}`}
      onClick={() => onClick?.(conv)}
      className="w-full flex items-center gap-3 p-3 rounded-xl hover:bg-white/[0.06] active:bg-white/[0.08] transition-colors text-left"
    >
      <div className="w-12 h-12 rounded-xl overflow-hidden bg-white/5 shrink-0 ring-1 ring-white/10">
        {conv.car_image ? (
          <img
            src={resolveMediaUrl(conv.car_image)}
            alt=""
            referrerPolicy="no-referrer"
            className="w-full h-full object-cover"
          />
        ) : (
          <MessageCircle className="w-6 h-6 text-electric m-3" strokeWidth={1.5} />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline justify-between gap-2">
          <span className="font-medium text-sm truncate text-white">{conv.other_name}</span>
          {conv.last_message_at && (
            <span className="text-[10px] text-slate-500 shrink-0 tabular-nums">
              {formatConversationDate(conv.last_message_at)}
            </span>
          )}
        </div>
        <div className="text-xs text-slate-500 truncate">{conv.car_label}</div>
        <div className="text-sm text-slate-400 truncate mt-0.5">
          {conv.last_message || "Nincs üzenet még"}
        </div>
      </div>
      <div className="flex flex-col items-end gap-1.5 shrink-0">
        {conv.pending_offer && (
          <span
            data-testid={`${testidPrefix}-offer-${conv.id}`}
            title="Ajánlat vár válaszra"
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-400 text-[10px] font-medium"
          >
            <HandCoins className="w-3 h-3" strokeWidth={1.5} /> Ajánlat
          </span>
        )}
        {conv.unread > 0 && (
          <span
            data-testid={`${testidPrefix}-unread-${conv.id}`}
            className="min-w-[20px] h-5 px-1.5 rounded-full bg-electric text-white text-xs flex items-center justify-center font-medium"
          >
            {conv.unread}
          </span>
        )}
      </div>
    </button>
  );
}

export function ChatConversationList({ convs, onSelect, emptyHint, testidPrefix }) {
  if (!convs?.length) {
    return (
      <div className="flex flex-col items-center justify-center text-center px-6 py-14 text-slate-400">
        <MessageCircle className="w-10 h-10 text-electric/40 mb-3" strokeWidth={1.25} />
        <p className="text-sm leading-relaxed max-w-[240px]">
          {emptyHint || "Még nincs beszélgetésed. Egy autó adatlapján indíthatod az első üzenetet."}
        </p>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-white/5" data-testid="chat-conversation-list">
      {convs.map((c) => (
        <li key={c.id}>
          <ChatConversationRow conv={c} onClick={onSelect} testidPrefix={testidPrefix} />
        </li>
      ))}
    </ul>
  );
}
